import { AppError } from './app-error'

export class PreconditionFailedError extends AppError {
  private static NAME: string = 'PreconditionFailedError'
  public static MESSAGE: string = 'Uma pré-condição necessária para essa operação não foi atendida.'

  constructor(message?: string | null, title?: string | undefined) {
    super(PreconditionFailedError.NAME, message ?? PreconditionFailedError.MESSAGE, title)
  }
}
